// Actions
export const REPORT_FETCH  = '[Report] Fetch'

// Mutations
export const REPORT_META   = '[Report] meta'
export const REPORT_OBTAIN = '[Report] obtain'
export const REPORT_CLEAR  = '[Report] clear'
export const REPORT_SET_LOADING = '[Report] set loading'
